// eslint-disable-next-line default-param-last -- Ignore
export const sanitizeInput = (object = {}, expectedKeys) => {
  const sanitizedInput = {};
  if (Array.isArray(expectedKeys)) {
    expectedKeys.forEach((expectedKey) => {
      if (object[expectedKey]) {
        sanitizedInput[expectedKey] = object[expectedKey];
      }
    });
  }
  return sanitizedInput;
};

export default sanitizeInput;
